import React, { useEffect, useRef } from "react";
import { View, Animated, Easing } from "react-native";
import Loader from "@assets/svg/Loader";

const CircularLoader = () => {
  const rotateRef = useRef(new Animated.Value(0)).current;
  useEffect(() => {
    Animated.loop(
      Animated.timing(rotateRef, {
        toValue: 1,
        duration: 1000,
        useNativeDriver: true,
      }),
    ).start();
  }, []);

  return (
    <Animated.View
      style={{
        backgroundColor: "transparent",
        transform: [
          {
            rotate: rotateRef.interpolate({
              inputRange: [0, 1],
              outputRange: ["0deg", "360deg"],
            }),
          },
        ],
      }}
    >
      <Loader />
    </Animated.View>
  );
};

export default CircularLoader;
